module.exports = __webpack_public_path__ + "img/66.a6333a46.jpg";